export const agreementsHeaders = [
  {
    headerName: "Agreement Title",
    headerId: "agreementTitle",
  },
  {
    headerName: "Entity Type",
    headerId: "entityType",
  },
  {
    headerName: "Agreement Text",
    headerId: "agreementText",
  },
  {
    headerName: "Active Status",
    headerId: "active",
  },
  {
    headerName: "Actions",
    headerId: "actions",
  },
];

export const ENTITY_TYPE_LABELS = {
  "1": "Church",
  "2": "Channel",
  "3": "Ministry",
};
